
export const isMobile = {
    Android: () => /Android/i.test(navigator.userAgent),
  
    iOS: () => /iPhone|iPad|iPod/i.test(navigator.userAgent),
  
    BlackBerry: () => /BlackBerry/i.test(navigator.userAgent),
  
    Opera: () => /Opera Mini/i.test(navigator.userAgent),
  
    Windows: () => /IEMobile/i.test(navigator.userAgent),
  
    Tablet: () => /Tablet|iPad/i.test(navigator.userAgent),
  
    Any: function () {
      return (
        this.Android() ||
        this.iOS() ||
        this.BlackBerry() ||
        this.Opera() ||
        this.Windows() ||
        this.Tablet()
      );
    }
  };

  export default isMobile;